import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { FaWhatsapp, FaFacebookF, FaInstagram } from 'react-icons/fa';
import { CONTACTO } from '../../constants';
import './Footer.css';

function Footer() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Delay más largo para que aparezca después de todos los demás elementos
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 1200); // 1.2 segundos después del inicio

    return () => clearTimeout(timer);
  }, []);

  return (
    <footer className={`footer pt-4 pb-3 ${isLoaded ? 'footer-loaded' : ''}`}>
      <Container fluid="lg pt-4">
        <Row className="gy-4">
          <Col xs={12} lg={3}>
            <h6 className="footer-title">iCase Oeste</h6>
            <NavLink to="/fundas" className="footer-link footer-main">Fundas</NavLink>
            <NavLink to="/accesorios" className="footer-link footer-main">Accesorios</NavLink>
            <NavLink to="/vidrios" className="footer-link footer-main">Vidrios</NavLink>
          </Col>

          <Col xs={12} lg={3}>
            <h6 className="footer-title">Contáctanos</h6>
            <a href={`https://wa.me/${CONTACTO.WHATSAPP_NUMERO}`} target="_blank" rel="noopener noreferrer" className="footer-contact-link">
              <p className="footer-contact"><FaWhatsapp className="plain-icon" /> {CONTACTO.WHATSAPP_DISPLAY}</p>
            </a>
            <a href={CONTACTO.INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="footer-contact-link">
              <p className="footer-contact"><FaInstagram className="plain-icon" /> {CONTACTO.INSTAGRAM_HANDLE.replace('@', '')}</p>
            </a>
          </Col>

          <Col xs={12} lg={3}>
            <h6 className="footer-title">Medios de pago</h6>
            <p className="footer-text">Mercado Pago</p>
            <p className="footer-text">Efectivo (retiro en Haedo)</p>
          </Col>

          <Col xs={12} lg={3}>
            <h6 className="footer-title">Envíos</h6>
            <p className="footer-text">Via Cargo (A todo el país)</p>
            <p className="footer-text">Moto mensajería (AMBA)</p>
            <p className="footer-text">Retiro por Haedo</p>
          </Col>
        </Row>

        <div className="footer-bottom">
          <div className="footer-left">
            <small className="footer-copy">
              &copy; {new Date().getFullYear()} <a href="https://higherweb.com.ar" className="footer-link" target="_blank" rel="noreferrer">HigherWeb</a> | Todos los derechos reservados
            </small>
          </div>
          <div className="footer-right">
            <a href="https://www.instagram.com/icase.oeste/" target="_blank" rel="noreferrer" className="footer-social">
              <FaInstagram />
            </a>
            <a href="https://www.facebook.com/share/17AgdT29Ui/?mibextid=wwXIfr" target="_blank" rel="noreferrer" className="footer-social">
              <FaFacebookF />
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
